import vueAppInitiator from './modules/vue-app-initiator';
import AuthorizedOrganizations from './vue-components/AuthorizedOrganizations';
import SwiperAuth from './vue-components/SwiperAuth';

const vueApps = [
    {
        el: '#auth-organizations',
        components: {
            AuthorizedOrganizations
        }
    },
    {
        el: '.js--swiper-auth',
        components: {
            SwiperAuth
        }
    },
];

document.addEventListener('DOMContentLoaded', () => vueAppInitiator(vueApps));
